module.exports = __webpack_public_path__ + "img/img_nodata.ec8badf9.jpg";